import { CancelTokenSource } from 'axios'
import axios from 'services/axios'
import { ENDPOINTS } from 'const/endpoints'
import _ from 'lodash'
import { errorNotify } from 'utils/toster'
import { commonMessages } from 'utils/messages'
import { onCreateEndpointsWithClientid } from 'utils/common'
import { IProvidersParams } from 'modules/Providers/Provider.interfaces'
import { IPagination } from 'types/entities'

export function getAllCity(params?: any, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)

	const promise = axios
		.get(`${onCreateEndpointsWithClientid(ENDPOINTS.CITY_LIST)}`, {
			params: {
				search: filteredParams?.citySearch,
				state: filteredParams?.stateID,
			},
			// cancelToken: source?.token,
		})
		.then((res) => {
			return res.data
		})

	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getStats(params?: any, clientId?: string | undefined, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios
		.get(`${ENDPOINTS.DASHBOARD_STATS}/${clientId}`, {
			params: {
				currentDate: filteredParams?.currentDate,
			},
		})
		.then((res) => {
			return res.data
		})

	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function downloadExcel(
	clientId: string | undefined,
	params: any,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)

	const checkPath = `${ENDPOINTS.DOWNLOAD_PROVIDER_EXCEL}/${clientId}`
	const promise = axios
		.get(checkPath, {
			params: filteredParams,
			responseType: 'blob',
		})
		.then((response) => {
			// Create a temporary URL object to generate a download link
			const url = window.URL.createObjectURL(new Blob([response.data]))
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'patients.xls')

			// Simulate a click event to trigger the download
			document.body.appendChild(link)
			link.click()

			// Clean up the temporary URL object
			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		})
		.catch(() => {
			errorNotify('Error downloading PDF')
		})
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}

export function getMemberPartnerList(
	params?: Partial<IProvidersParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IPagination<Partial<any>>>(
		onCreateEndpointsWithClientid(ENDPOINTS.PARTNER_LIST_BY_CLIENT),
		{
			params: filteredParams,
		},
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}
//Newly created function for messages
export function getMemberPartnerListForMessages(
	params?: Partial<IProvidersParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IPagination<Partial<any>>>(
		onCreateEndpointsWithClientid(ENDPOINTS.MEMBER_PARTNERS),
		{
			params: filteredParams,
		},
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}
